define(function () {
    var IpsModelCollection = require('civicsBase/ipsModelCollection');

    return IpsModelCollection.extend({
        urlRoot: '/delegate/civics-api/api',
        url: '/delegate/civics-api/api/portal/myinstrumentmilestones',
        parse: function (response) {
            var data = response.data ? response.data : [];
            var values = [];
            var returnValues = [];

            // Step 1: Iterate through data and create objects
            for (var i = 0; i < data.length; i++) {
                if (data[i].milestoneCode.trim() !== '') {
                    var obj = {
                        value: data[i].milestoneCode, // Milestone code as unique key
                        displayName: data[i].milestoneCode.trim(), // Milestone description (or code)
                        propertyName: 'instrumentMilestoneCode',
                    };
                    values.push(obj);
                }
            }

            // Step 2: Deduplicate based on displayName
            returnValues = _.uniq(values, function (e) {
                return e.displayName.toLowerCase(); // Ensure unique display names
            });

            // Step 3: Sort by displayName
            returnValues.sort(function (a, b) {
                return a.displayName.localeCompare(b.displayName, undefined, { numeric: true, sensitivity: 'base' });
            });

            // Step 4: Group related values by displayName
            var groupByDisplayName = _.groupBy(values, function (e) {
                return e.displayName; // Group all entries with the same display name
            });

            // Step 5: Add relatedValues to deduplicated entries
            _.each(returnValues, function (rtnObj) {
                rtnObj.relatedValues = [];

                _.each(groupByDisplayName[rtnObj.displayName], function (grpByObj) {
                    if (grpByObj.value !== rtnObj.value && rtnObj.relatedValues.indexOf(grpByObj.value) === -1) {
                        rtnObj.relatedValues.push(grpByObj.value);
                    }
                });
            });

            // Step 6: Return deduplicated and processed values
            return returnValues;
        },
    });
});
